module.exports = __webpack_public_path__ + "static/media/historico_fornecedor.577824ed.png";